const Loading = {
  show() {
    this.hide()

    const loadingEl = document.createElement('div')
    loadingEl.id = 'global-loading'
    loadingEl.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `

    const spinnerEl = document.createElement('div')
    spinnerEl.style.cssText = `
      width: 50px;
      height: 50px;
      border: 5px solid #f3f3f3;
      border-top: 5px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    `

    loadingEl.appendChild(spinnerEl)
    document.body.appendChild(loadingEl)

    // 添加动画样式
    const style = document.createElement('style')
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `

    document.head.appendChild(style)
  },

  hide() {
    document.querySelectorAll('#global-loading').forEach(el => el.remove())
  }
}

export default {
  install(Vue) {
    Vue.prototype.$loading = Loading
  }
}
